import { environment } from 'src/environments/environment';

export const storageDict = {
  authLocalStorageToken: `${environment.appVersion}-${environment.USERDATA_KEY}`,
  cpptUIToggle: 'cpptUIToggle',
  appointmentUIToggle: 'appointmentUIToggle',
  fcmTopicsSubscribed: 'fcmTopicsSubscribed',
  fcmToken: 'fcm_token',
  headOffice: 'headOffice',
  idLogin: 'idLogin',
  instalasiMedis: 'instalasiMedis',
  karyawan: 'karyawan',
  klinik: 'klinik',
  loket: 'loket',
  loketFarmasi: 'lktFarm',
  refreshToken: 'refreshToken',
  token: 'token',
  clientLocation: 'clientLocation',
  dwConfig: 'dwConfig',
  loginAttempts: 'lAt',
  posEwalletPayment: 'posEwp',
  tindakanCache: 'tinchc',
  selectableCache: 'selchc',
  userModuleAccess: 'uModules',
  posRecentItems: 'posRecents',
  dashboardAlerts: 'dsAlt',
  formMedisDrafts: 'fmdsDraft',
  cpptDraft: 'cpptDraft',
  cpptQueue: 'cpptQueue',
  excelColumn: 'excColumn',
  inpatientDoctorId: 'inpatientDoctorId',
  inpatientGroupRoomId: 'inpatientGroupRoomId',
};
